/** i18n key for sport display names: `t(sportTranslationKey(id), { defaultValue })` */
export function sportTranslationKey(sportId: number): string {
  return `sports.${sportId}`;
}
